import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

import Home from './Home/Home';
import Pallettes from './Palettes/Pallettes';
import Converter from './Converter/Converter';

import {hexColorDelta} from './../components/UniversalMethods'

import './../styles/styles.css'
import './../styles/icons.css'

class App extends React.Component {

  constructor(props){
    super(props);
    this.state = {};
    
    this.baseColors = {
      text: '000',
      background: 'f3f3f3'
    };
  }

  componentDidMount = () => {

  }

  updateColor = (color) => {
    this.titleColor = color;
    this.baseColors = {
      highlightText: color,
      text: hexColorDelta(color, 'ffffff') > 0.7? 'fff' : '2a2a2a',
      background: hexColorDelta(color, 'ffffff') > 0.7? '2a2a2a' : 'fff',
    };
  }

  render() {

      console.log(this.state.palette);
      return <BrowserRouter>
            <Route exact path={['/']} component = {props => 
                <Home {...props} baseColors={this.baseColors}/>
            } />
            <Route exact path={['/Pallettes']} component = {props => 
                <Pallettes {...props}/>
            } />
            <Route exact path={['/hex/', '/hex/:id']} component = {props => 
                <Converter {...props} updateColor={this.updateColor}/>
            } />
        </BrowserRouter>
  }
}

export default App;
